import React, { useContext, useEffect, useState } from 'react'
import { apiGet, apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Table from './districtTable'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import DistrictModal from './districtModal'
import { useLocation } from 'react-router-dom'
import helper from 'utils/helpers'
import useToastContext from 'hooks/useToastContext'

function District () {
  const { t } = useTranslation()
  const location = useLocation()
  const notification = useToastContext();
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [districts, setAllDistricts] = useState([])
  const [page, setPage] = useState(location?.state?.page ? location?.state?.page : 1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [sampleFilePath, setSampleFilePath] = useState('')
  const [filterData, setFilterData] = useState({category:'',searchkey:'',startDate:'',endDate:'',isReset:false, isFilter:false})
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })
  const manager = user?.permission?.find(e => e.manager === 'category') ?? {}

  const getAllDistricts = async (data) => {
    try {
      const {category, searchkey, isFilter} = filterData
      if ((data?.deletePage && !(districts?.length > 1) || (isFilter && category && data?.statusChange && !(districts?.length > 1))) ) {
        if (!(districts?.length > 1)) {
          setPage(page - 1)
          setIsDelete(true)
          setPaginationObj({ ...paginationObj, page: page - 1 })
        }
      }
      else {
        setIsDelete(false)
      }
      const payload = {
        page,
        pageSize,
        status: category,
        // start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        // end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey?.trim(),
        sort_key: sort.sort_key,
        sort_type: sort.sort_type
      }

      const path = apiPath.districtList
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setAllDistricts(response?.docs)
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null
        })
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handleFileChange = async (e) => {
    const file = e?.target?.files[0];
    const isValidCSV = validateFiles(file);
    if (isValidCSV) {
      const formData = new FormData();
      formData.append("csvFile", file);
      const path = apiPath.uploadDistrictCSVFile;
      const result = await apiPost(path, formData);
      if (result?.data?.success) {
        notification.success(result.data.message);
        getAllDistricts()
      } else {
        notification.error(result.data.message);
      }
    }
  };

  const validateFiles = (uploadFile) => {
    let csvFileError = "";
    const supportedTypes = [
      "text/csv",
    ];

    if (!uploadFile?.name?.endsWith('.xlsx')) {
      csvFileError = "Only xlsx files are supported.";
    }
    if (csvFileError) {
      alert(csvFileError);
      return false;
    } else {
      return true;
    }
  };
  
  const getSampleFilePath = async() => {
    try{
      const path = apiPath.downloadDistrictSampleFile
      const result = await apiGet(path)
      if (result?.status === 200) {
        const response = result?.data?.results
        setSampleFilePath(response?.sampleFile)
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const toggleModal = (item) => {
    setShowModal(!showModal)
    setItem(item ?? {})
  }

  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleSearchKey = (e) => {
    e.preventDefault()
    setFilterData({...filterData, searchkey:e.target.value, isFilter:true})
    setPage(1)
  }

  const handleReset = () => {
    setFilterData({category:'',searchkey:'',isReset:true, isFilter:false})
    setPage(1)
    setIsDelete(true)
  }

  const statusPage = (e) =>{
    setFilterData({...filterData, category:e.target.value, isFilter:true})
    setPage(1)
    setIsDelete(true)
  }

  useEffect(() => {
    updatePageName(t('O_DISTRICTS'))
    getSampleFilePath()
  }, [])

  useEffect(() => {
    updatePageName(t('O_DISTRICTS'))
    getAllDistricts()
  }, [page, filterData, sort])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <div className='border-b border-b-[#E3E3E3] grid 2xl:grid-cols-2 px-4 py-3 pt-5'>
              <div className='flex flex-wrap  items-center'>
                <div className='flex items-center flex-wrap justify-start'>     
                <div className='flex items-center px-4 mb-3'>
                  <div className='flex'>
                    <div className='relative '>
                      <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                        {!filterData?.searchkey && (
                          <svg
                            aria-hidden='true'
                            className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                            />
                          </svg>
                        )}
                      </div>
                      <input
                        type='text'
                        id='default-search'
                        className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                        placeholder={t('O_SEARCH_BY_NAME')}
                        value={filterData?.searchkey}
                        title=''
                        required
                        onChange={(e) => handleSearchKey(e)}
                      />
                    </div>
                  </div>
                </div>
                  <div className='flex items-center mb-3 ml-3'>
                    <select
                      id='countries'
                      type=' password'
                      name='floating_password'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      value={filterData?.category}
                      onChange={(e)=>statusPage(e)}
                    >
                      <option defaultValue value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>
              <div className='flex items-start 2xl:justify-end px-4'>
              {(manager?.add ||
                user?.role==='admin') && (
                <button
                  type='button'
                  className='bg-LightBlue flex text-sm px-8 2xl:ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  onClick={() => helper.downloadSampleDistrictFile(sampleFilePath)}
                >
                  {t('O_DOWNLOAD_SAMPLE')}
                </button>
              )}
              {(manager?.add ||
                user?.role==='admin') && (
              <div className='relative w-[208px]  cursor-pointer'>
              <input
                  onChange={handleFileChange}
                  type='file'
                  className='w-full z-20 relative opacity-0 cursor-pointer pb-0 bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                >
                  
                </input>
                <span className='top-0 w-full text-center cursor-pointer  bg-LightBlue  text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap block absolute '>{t('O_UPLOAD_CSV')}</span>
              </div>
              )}
              </div>
            </div>
            <Table
              districts={districts}
              user={user}
              getAllDistricts={getAllDistricts}
              handelEdit={toggleModal}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
      <>
      {showModal && <DistrictModal show={showModal} onHide={toggleModal} getAllDistricts={getAllDistricts} editData={item}  setPage={setPage}/>}
      </>
    </div>
  )
}
export default District
